import { module as Module } from 'modujs';

export default class CopyLink extends Module {
    static CLASS = {
        COPIED: '-is-copied'
    };

    constructor(m) {
        super(m);

        // UI
        this.$button = this.el;

        this.events = {
            click: {
                button: 'copyEmail'
            }
        };
    }

    // =============================================================================
    // Lifecycle
    // =============================================================================
    init() {
        if (this.$button) {
            this.$button.addEventListener('click', this.copyEmail.bind(this));
        }
    }

    destroy() {
        if (this.$button) {
            this.$button.removeEventListener('click', this.copyEmail.bind(this));
        }
    }

    async copyEmail(event) {
        const button = event.currentTarget;
        const email = button.getAttribute('data-copy-link-email');

        try {
            await navigator.clipboard.writeText(email);
            button.setAttribute('aria-live', 'polite');

            button.classList.add('-is-copied');
            setTimeout(() => {
                button.classList.remove('-is-copied');
            }, 1000);
            console.log('Email copied to clipboard');
        } catch (error) {
            console.error(error.message);
        }
    }
}
